import axios from "axios";
import { config } from "../../enviroment";
import { history } from "../../helpers/history";
import { routePaths } from "../config/route-paths";
import { bearerTokenService } from "../../services/bearer.service";
import { refreshBearerService } from "../../services/refresh.bearer.service";
import Cookies from "universal-cookie";
 
const TIMEOUT = 1 * 60 * 1000;
// axios.defaults.timeout = TIMEOUT;
const envConfig = config;
let errCount=0;
export var isTokenRefreshing = null;

export const setIsTokenRefreshing = (isRefreshing) => {
  isTokenRefreshing = isRefreshing;
}

export const setupAxiosInterceptors = () => {
  const onRequestSuccess = async (config) => {
    config.headers.tenantCode = envConfig.parameters.TENANT_CODE;
    let authbearer = localStorage.getItem("authbearer");
    if (authbearer) {
      authbearer = JSON.parse(authbearer);
      let accessToken = authbearer.access_token;
      let dataExpiration = getExpirationDate(accessToken);
      let timeCheck = isExpired(dataExpiration);
      if (timeCheck && !config._retry && config.url !== envConfig.urls.REFRESH_BEARER && config.url !== envConfig.urls.GENERATE_BEARER) {
        config._retry = true;
        isTokenRefreshing = isTokenRefreshing ? isTokenRefreshing : refreshBearerService.refreshBearerToken();
        await isTokenRefreshing;
        isTokenRefreshing = null;
        let authbearer = localStorage.getItem("authbearer");
        authbearer = JSON.parse(authbearer);
        accessToken = authbearer.access_token;
      }
      config.headers.accessToken = `${accessToken}`;
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  };
  const onResponseSuccess = (response) => response;
  const onResponseError = (err) => {
    // const status = err.status || (err.response ? err.response.status : 0);
    // if (err.config.url === envConfig.urls.GENERATE_BEARER) {
    //   history.push(routePaths.RETRY);
    // }
    // if (
    //   err.config.url === envConfig.urls.LOGIN ||
    //   err.config.url === envConfig.urls.SIGNUP ||
    //   err.config.url === envConfig.urls.LABELS ||
    //   err.config.url === envConfig.urls.GENERATE_BEARER
    // ) {
    //   if (status === 500) {
    //     history.push(routePaths.RETRY);
    //   }
    // }
    // if (status === 401) {
    //   bearerTokenService.refreshBearerToken();
    // }
    return Promise.reject(err);
  };
  axios.interceptors.request.use(onRequestSuccess);
  axios.interceptors.response.use(onResponseSuccess, onResponseError);
};

const getExpirationDate = (jwtToken) => {
  if (!jwtToken) {
    return null;
  }
  const jwt = JSON.parse(atob(jwtToken.split(".")[1]));
  return (jwt && jwt.exp && jwt.exp * 1000) || null;
};

const isExpired = (exp) => {
  if (!exp) {
    return false;
  }
  return Date.now() > exp;
};
